import { create } from 'axios'
const baseUrl = process.env.REACT_APP_BASE_URL

const API = create({
  baseURL: baseUrl,
})

export const signUp = (formData) => API.post('/auth/signup', formData)
export const signIn = ({ email, password }) =>
  API.post('/auth/signin', { email, password })
export const refreshToken = (headers) => API.get('/auth/refresh', headers)
